/**
 * In the store a canvas note takes the following structure;
 
    {
        id, // Map element ID
        meta, // The actual map element metadata
        flowId, // The flow the note is a member of
        isOpen, // Determines whether the note content is displayed
        readOnly, // Determines whether the note content can be modified
    }

 */

import actionTypes from '../actions/reduxActions/actionTypes';
import { map, merge, indexBy, prop, mergeWith, reduce, values, pipe } from 'ramda';

const setNotes = pipe(
    map(
        indexBy(
            prop('id'),
        ),
    ),
    reduce(mergeWith(merge), {}),
    values,
);

const canvasNotes = (notes = [], { type, payload, error, meta }) => {

    switch (type) {

    case actionTypes.NOTE_UPDATE:
    case actionTypes.MAP_ELEMENT_SET: { // Listening for both events to keep notes store in sync
        const note = payload;
        if (note.elementType === 'note') {
            return notes.map(n => n.id === note.id ? {
                ...n,
                meta: note,

                // This makes sure the note goes back to read only view when saved
                readOnly: type === actionTypes.MAP_ELEMENT_SET ? n.readOnly : true,
            } : n);
        }

        return notes;
    }

    case actionTypes.NOTE_ADD: {
        const { note, flowId } = payload;
        const newNote = {
            id: note.id,
            meta: note,
            flowId,
            isOpen: true,
            readOnly: false,
        };
        return [...notes, newNote];
    }

    case actionTypes.NOTE_SET_ALL: {
        const { items, flowId } = payload;
        const notesToSet = items.map(item => ({
            id: item.id,
            meta: item,
            flowId,
            isOpen: false,
            readOnly: true,
        }));

        return setNotes([notes, notesToSet]);
    }

    case actionTypes.NOTE_EDIT: {
        const { id } = payload;
        return notes.map(note => note.id === id ? { ...note, readOnly: !note.readOnly } : note);
    }

    case actionTypes.NOTE_TOGGLE_VISIBILITY: {
        const { id } = payload;
        return notes.map(note => note.id === id ? { ...note, isOpen: !note.isOpen } : note);
    }

    case actionTypes.MAP_ELEMENT_DELETE:
        return notes.filter(note => note.id !== payload);

    default:
        return notes;
    }
};

export default canvasNotes;
